import type { FullHeadMPRViewSnapshot } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import {
  FULL_HEAD_MPR_PLANE_TOLERANCE,
  isSameFullHeadMprPhysicalPlane,
} from '@/features/MPR';

import {
  FULL_HEAD_MPR_PROJECTION_TO_SERIES,
  type FullHeadMprSliceGroupView,
  type ToothSliceGeometry,
} from '../config';

export const resolveFullHeadMprSeriesTile = ({
  groups,
  input,
  snapshot,
}: {
  groups: FullHeadMprSliceGroupView[];
  input: ToothSliceGeometry | null;
  snapshot: FullHeadMPRViewSnapshot;
}) => {
  const { view } = snapshot;
  const group = groups.find(
    (candidate) =>
      candidate.seriesName ===
      FULL_HEAD_MPR_PROJECTION_TO_SERIES[view.projection],
  );
  if (!input || !group || view.volumeFileID !== input.volumeFileID) {
    return null;
  }

  const { normal } = group.frame.plane;
  const offsetMm =
    (view.centerMm.x - input.origin.x) * normal.x +
    (view.centerMm.y - input.origin.y) * normal.y +
    (view.centerMm.z - input.origin.z) * normal.z;
  const tile = group.tiles.find(
    (candidate) =>
      candidate.kind === 'series' &&
      Math.abs(candidate.offsetMm - offsetMm) <= FULL_HEAD_MPR_PLANE_TOLERANCE,
  );
  if (!tile) {
    return null;
  }

  return isSameFullHeadMprPhysicalPlane(view, {
    ...view,
    centerMm: {
      x: input.origin.x + normal.x * tile.offsetMm,
      y: input.origin.y + normal.y * tile.offsetMm,
      z: input.origin.z + normal.z * tile.offsetMm,
    },
    normal,
  })
    ? tile
    : null;
};
